export class SelectionMenuController {

    constructor($log, $timeout) {
        'ngInject';

        this.$log = $log;
        this.$timeout = $timeout;

        this.$log.debug('SelectionMenuController::constructor');

        this.active = true;

    }

    selectItem(item) {

        if (this.active) this.onItemSelected({item: item})

        this.active = false;

        this.$timeout(() => {
           this.active = true;
        }, 1000);

    }

}



// WEBPACK FOOTER //
// ./src/js/components/selection-menu/selection-menu.controller.js